import { getUserInfo } from 'ui-addon-upgrades/_core/common/api/getUserInfo';
export const getCanViewNewSeats = () => {
  return getUserInfo().then(({
    user
  }) => {
    return user.scopes.includes('seats-access');
  });
};